import axios from 'axios'; 


export const getProfileFromAPI = () => {
    return axios
        .get(`${window.GENESIS_CMS_API_URL}/v2/profiles/me?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}`);
};
